import { Controller } from "stimulus"

// Rafraîchit la liste des salles après le lancement d'une génération,
// sans que l'utilisateur ait besoin de recharger la page.
//
// La mise à jour instantanée passe normalement par CableReady (broadcast du worker).
// Ce controller sert de filet de sécurité : si le broadcast est manqué
// (page rechargée après le redirect avant l'abonnement ActionCable),
// on interroge le serveur jusqu'à ce que les salles apparaissent.
//
// NB: Stimulus 2.0 n'accepte que la forme courte des values (String/Number/Boolean).
// Les valeurs par défaut sont donc gérées manuellement dans le code.
export default class extends Controller {
  static values = {
    url: String,
    active: Boolean,
    interval: Number,
    maxAttempts: Number
  }

  connect() {
    if (!this.activeValue) return

    this.attempts = 0
    this.maxAttempts = this.maxAttemptsValue || 20
    this.timer = setInterval(() => this.poll(), this.intervalValue || 3000)
  }

  disconnect() {
    this.stop()
  }

  async poll() {
    this.attempts += 1
    if (this.attempts > this.maxAttempts) {
      this.stop()
      return
    }

    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "application/json" },
        credentials: "same-origin"
      })
      if (!response.ok) return

      const data = await response.json()
      if (typeof data.html === "string") {
        this.element.innerHTML = data.html
      }
      // Dès qu'au moins une salle existe, la génération est terminée.
      if (data.salles_count && data.salles_count > 0) {
        this.stop()
      }
    } catch (error) {
      // On ignore les erreurs réseau ponctuelles, le prochain tick réessaiera.
    }
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
